import ganttViewModel from '$$ganttViewModel';
import helpers from './helpers';

export default {
  fromStore(projectTasksData, ganttInstance) {
    const ganttIds = ganttViewModel.getGanttIDs();

    if (ganttIds.includes(projectTasksData.id)) {
      helpers.clearAndParse(ganttInstance, true);
      ganttInstance.callEvent('workloadClearAndParse');
    }
  },

  fromGantt() {

  },
};
